const axios = require('axios').default;
axios.defaults.adapter = require('axios/lib/adapters/http');

async function getHeaders(factoryHeader, paramHeader, customHeaders) {
  let h = {};
  if (typeof factoryHeader === 'function') {
    h = await factoryHeader();
  }
  return {...paramHeader, ...customHeaders, ...h};
  
}

const log = (isDebug, data) => {
  if (isDebug) {
    console.log(typeof data === "object" ? JSON.stringify(data) : data);
  }
}
const FactoryReqJson = (factoryHeader = null) => {
  
  
  const customHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
  
  const handleCatchError = (error, url) => {
    log(true, `error in ${url}`);
    log(true, error.response);
    
    if (error.response && typeof error.response.data !== 'undefined') {
      return error.response.data;
    }
    
    return {
      success: false,
      msg: error
    };
  };
  
  
  return {
    
    
    requestGET: async (url, paramHeader = null, isDebug = false) => {
      log(isDebug, url);
      
      let headers = await getHeaders(factoryHeader, paramHeader, customHeaders);
      
      try {
        return await axios
          .get(url, {headers})
          .then(function (response) {
            log(isDebug, response);
            return response.data;
          })
          .catch(function (error) {
            return handleCatchError(error, url);
          });
      } catch (error) {
        return handleCatchError(error, url);
      }
    },
    
    requestPOST: async (url, dataObject, paramHeader, isDebug = false) => {
      
      log(url);
      
      let headers = await getHeaders(factoryHeader, paramHeader, customHeaders);
      
      try {
        return await axios
          .post(url, dataObject, {headers})
          .then(function (response) {
            log(response);
            return response.data;
          })
          .catch(function (error) {
            return handleCatchError(error, url);
          });
      } catch (error) {
        return handleCatchError(error, url);
      }
    },
    
    requestPUT: async (url, dataObject, paramHeader = null) => {
      
      let headers = await getHeaders(factoryHeader, paramHeader, customHeaders);
      
      try {
        return await axios
          .put(url, dataObject, {headers})
          .then(function (response) {
            log(response);
            return response.data;
          })
          .catch(function (error) {
            return handleCatchError(error, url);
          });
      } catch (error) {
        return handleCatchError(error, url);
      }
    },
    
    
    requestDELETE: async (url, paramHeader, isDebug = false) => {
      
      log(url);
      let headers = await getHeaders(factoryHeader, paramHeader, customHeaders);
      
      try {
        return await axios
          .delete(url, {headers})
          .then(function (response) {
            log(response);
            return response.data;
          })
          .catch(function (error) {
            return handleCatchError(error, url);
          });
      } catch (error) {
        return handleCatchError(error, url);
      }
    },
    
    
    requestPUTFile: async (url, objectFile, isDebug = false) => {
      
      log(url);
      const options = {
        headers: {
          'Content-Type': objectFile.type
        }
      };
      
      try {
        return await axios
          .put(url, objectFile, options)
          .then(function (response) {
            log(response);
            
            return response.data;
          })
          .catch(function (error) {
            return handleCatchError(error, url);
          });
      } catch (error) {
        return handleCatchError(error, url);
      }
    },
    
    uploadFilePOST: async (url, objectFile, paramFileName, paramHeader, isDebug = false) => {
      
      log(url);
      //Este metodo  no es json
      const customHeaders = {'Content-Type': 'multipart/form-data'};
      let facHeaders = {};
      if (typeof factoryHeader === 'function') {
        facHeaders = factoryHeader();
      }
      
      let headers = {...paramHeader, customHeaders, ...facHeaders};
      
      const formData = new FormData();
      
      formData.append(paramFileName, objectFile);
      
      try {
        return await axios
          .post(url, formData, headers)
          .then(function (response) {
            log(response);
            return response.data;
          })
          .catch(function (error) {
            return handleCatchError(error, url);
          });
      } catch (error) {
        return handleCatchError(error, url);
      }
    }
  }
  
};

export default FactoryReqJson;